import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { templateDetails } from "../../../../slice/template";

import { faCheck, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import lang from "../../../../assets/lang/icons.json";

import style from "./template.module.css";
import Pro from "./../../Pro/Pro";
import { Tooltip } from "@mui/material";

export default function Template() {
  const dispatch = useDispatch();
  const [getUserTempid, setGetUserTempid] = useState("");
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const [tempName, setTempname] = useState("temp1");

  const [active, setActive] = useState("temp1");
  const handleInput = (e) => {
    e.preventDefault();

    setTempname(e.target.getAttribute("data-name-id"));
    setActive(e.target.getAttribute("data-name-id"));
  };

  const fetch = async () => {
    try {
      const response = await axios.get("/getUser");
      const user = await response.data.user;
      setGetUserTempid(user.current_temp_id);
      if (user.current_temp_id !== null) {
        dispatch(templateDetails(user.edit_template.template_name));
        setActive(user.edit_template.template_name);
        setTempname(user.edit_template.template_name);
      } else {
        dispatch(templateDetails(tempName));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isAuth) {
      fetch();
    }
  }, []);

  //on above dont use const in array cause re-render effect
  useEffect(() => {
    dispatch(templateDetails(tempName));
  }, [dispatch, tempName]);
  return (
    <div className={`${style.templates}`}>
      <div className={`m-2 ${style.templatesWrap}`}>
        <span className="custom-header">Select Your Template</span>
        <div className="text-center w-100 my-3 ">FREE TEMPLATES</div>

        <div className={`${style.TemplateItems}`} data-name-id="temp1">
          {/* <h6 data-name-id="temp1" onClick={handleInput}>
            Normal
          </h6> */}
          <div className={`${style.TempImage}`}>
            <img
              className={
                active === "temp1"
                  ? `${style.ActiveTemp} bg-white`
                  : `${style.Inactivetemp} bg-white`
              }
              data-name-id="temp1"
              onClick={handleInput}
              src={`${lang.templateImages.temp1}`}
              alt="no img"
            ></img>
          </div>
          {/* <div
            className={`${style.isActiveTemplate}`}
            style={{ display: active === "temp1" ? "flex" : "none" }}
          >
            <FontAwesomeIcon icon={faCheck} />
          </div> */}
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp2">
          {/* <h6 data-name-id="temp2" onClick={handleInput}>
            Social Bottom
          </h6> */}
          <img
            className={
              active === "temp2"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp2"
            onClick={handleInput}
            src={`${lang.templateImages.temp2}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp3">
          {/* <h6 data-name-id="temp3" onClick={handleInput}>
            Social Right <Pro marginValue="5px" />
          </h6> */}
          <img
            className={
              active === "temp3"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp3"
            onClick={handleInput}
            src={`${lang.templateImages.temp3}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp4">
          {/* <h6 data-name-id="temp4" onClick={handleInput}>
            Social Left
          </h6> */}
          <img
            className={
              active === "temp4"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp4"
            onClick={handleInput}
            src={`${lang.templateImages.temp4}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp9">
          {/* <h6 data-name-id="temp9" onClick={handleInput}>
            classic
          </h6> */}
          <img
            className={
              active === "temp9"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp9"
            onClick={handleInput}
            src={`${lang.templateImages.temp9}`}
            alt="no img"
          ></img>
        </div>
        <div className="text-center w-100 my-3 ">
          PRO TEMPLATES <Pro marginValue={3} />
        </div>
        <div className={`${style.TemplateItems}`} data-name-id="temp6">
          {/* <h6 data-name-id="temp6" onClick={handleInput}>
            Modern <Pro marginValue="5px" />
          </h6> */}
          <img
            className={
              active === "temp6"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp6"
            onClick={handleInput}
            src={`${lang.templateImages.temp6}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp7">
          {/* <h6 data-name-id="temp7" onClick={handleInput}>
            No Image
          </h6> */}
          <img
            className={
              active === "temp7"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp7"
            onClick={handleInput}
            src={`${lang.templateImages.temp7}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp8">
          {/* <h6 data-name-id="temp8" onClick={handleInput}>
            Email / Phone
          </h6> */}
          <img
            className={
              active === "temp8"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp8"
            onClick={handleInput}
            src={`${lang.templateImages.temp8}`}
            alt="no img"
          ></img>
        </div>
        {/* <div className="w-100">
          <span className="custom-header" style={{ width: "40%" }}>
            Design Templates
          </span>
          <Tooltip
            title={
              <span style={{ fontSize: "13px", color: "white" }}>
                For best image quality, we recommend to use up to 520px width
              </span>
            }
            placement="top"
          >
            <FontAwesomeIcon icon={faInfoCircle} className="ms-1" />
          </Tooltip>
        </div> */}

        <div className={`${style.TemplateItems}`} data-name-id="temp5">
          {/* <h6 data-name-id="temp5" onClick={handleInput}>
            Design 1
          </h6> */}
          <img
            className={
              active === "temp5"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp5"
            onClick={handleInput}
            src={`${lang.templateImages.temp5}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp10">
          {/* <h6 data-name-id="temp10" onClick={handleInput}>
            Design 2
          </h6> */}
          <img
            className={
              active === "temp10"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp10"
            onClick={handleInput}
            src={`${lang.templateImages.temp10}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp11">
          {/* <h6 data-name-id="temp11" onClick={handleInput}>
            Design 3 <Pro marginValue="5px" />
          </h6> */}
          <img
            className={
              active === "temp11"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp11"
            onClick={handleInput}
            src={`${lang.templateImages.temp11}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp12">
          {/* <h6 data-name-id="temp12" onClick={handleInput}>
            Design 4 <Pro marginValue="5px" />
          </h6> */}
          <img
            className={
              active === "temp12"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp12"
            onClick={handleInput}
            src={`${lang.templateImages.temp12}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp13">
          {/* <h6 data-name-id="temp13" onClick={handleInput}>
            Design 5 <Pro marginValue="5px" />
          </h6> */}
          <img
            className={
              active === "temp13"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp13"
            onClick={handleInput}
            src={`${lang.templateImages.temp13}`}
            alt="no img"
          ></img>
        </div>

        <div className={`${style.TemplateItems}`} data-name-id="temp14">
          {/* <h6 data-name-id="temp14" onClick={handleInput}>
            Banner Right
            <Pro marginValue="5px" />
          </h6> */}
          <img
            className={
              active === "temp14"
                ? `${style.ActiveTemp} bg-white`
                : `${style.Inactivetemp} bg-white`
            }
            data-name-id="temp14"
            onClick={handleInput}
            src={`${lang.templateImages.temp14}`}
            alt="no img"
          ></img>
        </div>
      </div>
    </div>
  );
}
